import { axios } from '@Root/API'

export const createForm = payload => {
  return axios.post(`cognito-forms`, payload)
}
